import * as Yup from 'yup';
import { PqrInFavorOf } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrInFavorOf = {
    inFavorOf: '',
    label: '',
};

export const validationSchema = Yup.object().shape({
    label: Yup.string(),
    inFavorOf: Yup.string().when('label', ([label], schema) => {
        return label === 'CERRADO'
            ? schema.required('Este campo es obligatorio para cerrar la PQR')
            : schema.notRequired();
    }),
});
